import React from 'react'
import ApiClient from '../helpers/ApiClient';
import axios from 'axios';




export const addAliumniLatestNews = async ({ file, title, description }) => {
    try {
        const response = await ApiClient.post(`/AlumniPage/addAlumniNews`, { file, title, description }, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        console.log("Response:", response);
        return response;
    } catch (error) {
        console.error("API Error:", error);
        throw error;
    }
};


export const getAlumniNewsData = async ({ page = 1, pageSize = 10 }) => {
    try {
        const response = await ApiClient.get(`/AlumniPage/getAlumniNews?page=${page}&page_size${pageSize}`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}

export const deleteNewsData = async ({ id }) => {
    try {
        const response = await ApiClient.delete(`/AlumniPage/deleteAlumniNews/${id}`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}

export const editAlumniData = async ({ id, title, description, file }) => {
    try {
        const response = await ApiClient.put(`/AlumniPage/updateAlumniNews/${id}`,
            { title, description, file },
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}